import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  CircularProgress,
  Container,
  Alert,
  Button
} from '@mui/material';
import api from '../../utils/api';

const EmailVerification = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');
  const verificationAttemptedRef = React.useRef(false);

  const verifyEmail = useCallback(async () => {
    if (verificationAttemptedRef.current) return;
    verificationAttemptedRef.current = true;

    try {
      const response = await api.get(`/auth/verify-email/${token}`);
      setStatus('success');
      setMessage(response.data.message);
      // Redirect to login after 3 seconds
      const timeoutId = setTimeout(() => {
        navigate('/login');
      }, 3000);
      return () => clearTimeout(timeoutId);
    } catch (error) {
      // Check if it's already verified
      if (error.response?.data?.message?.includes('already verified')) {
        setStatus('success');
        setMessage('Email already verified. You can now login.');
        const timeoutId = setTimeout(() => {
          navigate('/login');
        }, 3000);
        return () => clearTimeout(timeoutId);
      } else {
        setStatus('error');
        setMessage(error.response?.data?.message || 'Email verification failed');
      }
    }
  }, [token, navigate]);

  useEffect(() => {
    verifyEmail();
  }, [verifyEmail]);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2
        }}
      >
        {status === 'verifying' && (
          <>
            <CircularProgress />
            <Typography variant="h6">Verifying your email...</Typography>
          </>
        )}

        {status === 'success' && (
          <Alert severity="success" sx={{ width: '100%' }}>
            {message || 'Email verified successfully! Redirecting to login...'}
          </Alert>
        )}

        {status === 'error' && (
          <>
            <Alert severity="error" sx={{ width: '100%' }}>
              {message || 'Verification failed. Please try again.'}
            </Alert>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate('/login')}
            >
              Go to Login
            </Button>
          </>
        )}
      </Box>
    </Container>
  );
};

export default EmailVerification; 